import moment from 'moment/min/moment.min';
import { Map } from 'immutable';

/**
 * Returns the URL used to retrieve the next week of schedules for a particular user
 * @param {Number} id The user id to retrieve schedules for
 * @returns {string} The URL to query
 */
export function getScheduleUrl(id) {
  const from = moment().utc()
    .format('YYYY-MM-DD');
  const to = moment().utc()
    .add(7, 'days')
    .format('YYYY-MM-DD');

  return `/schedules?user_ids=${id}&from=${from}&to=${to}`;
}

/**
 * Takes an array of schedules and pulls out the current schedule if the user is currently
 * working or will be working withing the next hour, and the next schedule the user will work
 * @param {Array} data The list of schedules for this user
 * @returns {{current: *, next: *}} The current and next schedules.  If either is not present,
 * it will be `undefined`.
 */
export function processSchedules(data) {
  const schedules = data.filter(schedule => schedule.finish > moment().unix());

  let current; let next;
  if (schedules.length > 0) {
    const firstSchedule = {
      start: schedules[0].start,
      finish: schedules[0].finish,
      departmentId: schedules[0].department_id,
      detailsId: schedules[0].shift_detail_id,
    };

    if (firstSchedule.start < moment().add(1, 'hour').unix()) { // schedule.start < now + 1hr
      current = firstSchedule;
    } else {
      next = firstSchedule;
    }

    if (!next && schedules.length > 1) {
      next = {
        start: schedules[1].start,
        finish: schedules[1].finish,
        departmentId: schedules[1].department_id,
        detailsId: schedules[1].shift_detail_id,
      };
    }
  }

  return { current, next };
}

export function setSchedules(state, schedules) {
  const mappedSchedules = new Map({
    current: new Map(schedules.current),
    next: new Map(schedules.next),
  });

  return state.set('schedules', mappedSchedules);
}



// WEBPACK FOOTER //
// ./src/store/currentUser/lib.js